import { clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const mergeTailwindClasses = extendTailwindMerge({
  extend: { theme: { text: ["section-title"] } },
})

/**
 * Merge class names with Tailwind CSS classes
 * @param  {...string} inputs - Class names to merge
 * @returns {string} - Merged class names
 */
export function cn(...inputs) {
  return mergeTailwindClasses(clsx(inputs))
}

export const formatCountdown = (totalSeconds) => {
  if (!Number.isFinite(totalSeconds)) return '0:00'
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.max(0, totalSeconds % 60)
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}
